import { derived, writable } from 'svelte/store';

export type Direction = 'LTR' | 'RTL';
export const direction = writable<Direction>('LTR');

export const toggleDirection = (): void => {
	direction.update((value) => (value === 'LTR' ? 'RTL' : 'LTR'));
};

export const isLTR = derived(direction, (dir) => dir === 'LTR');
export const isRTL = derived(direction, (dir) => dir === 'RTL');
